import {
  IStorage,
  IStorageService,
  IStorageItem,
} from '../interfaces/IStorageService';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MemoryStorageService implements IStorageService {
  private _storage: IStorage;

  constructor() {
    this._storage = {};
  }

  public get length() {
    return Object.keys(this._storage).length;
  }

  public getItem(key: string): IStorageItem {
    return this._storage[key];
  }

  public setItem(key: string, value: IStorageItem): void {
    this._storage[key] = value;
  }

  public clear(): void {
    this._storage = {};
  }

  public removeItem(key: string): void {
    if (this._storage?.[key]) {
      delete this._storage[key];
    }
  }

  public key(index: number): string | null {
    return Object.values(this._storage)[index];
  }
}
